import React from 'react';
import Icon from '../../../components/AppIcon';

const SearchTypeToggle = ({ searchType, onSearchTypeChange, className = '' }) => {
  const searchOptions = [
    {
      type: 'cedula',
      label: 'Buscar por Cédula',
      icon: 'User',
      description: 'Ingresa tu número de cédula'
    },
    {
      type: 'ticket',
      label: 'Buscar por Boleto',
      icon: 'Ticket',
      description: 'Ingresa el número de boleto (solo números)'
    }
  ];

  return (
    <div className={`bg-card rounded-xl border border-border p-6 shadow-luxury ${className}`}>
      <div className="text-center mb-6">
        <h2 className="text-2xl font-heading font-bold text-gray-800 mb-2">
          Verificar Boletos
        </h2>
        <p className="text-gray-800 font-caption">
          Selecciona el método de búsqueda para verificar tus boletos
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {searchOptions?.map((option) => (
          <div
            key={option?.type}
            onClick={() => onSearchTypeChange(option?.type)}
            className={`p-4 rounded-lg border-2 cursor-pointer transition-premium ${
              searchType === option?.type
                ? 'border-secondary bg-secondary/10 shadow-golden'
                : 'border-border hover:border-secondary/50 hover:bg-muted/30'
            }`}
          >
            <div className="flex items-center space-x-3">
              <div className={`p-3 rounded-lg ${
                searchType === option?.type
                  ? 'bg-secondary text-secondary-foreground'
                  : 'bg-gray-800 text-white'
              }`}>
                <Icon name={option?.icon} size={20} />
              </div>
              <div className="flex-1">
                <h3 className={`font-body font-semibold ${
                  searchType === option?.type ? 'text-card-foreground' : 'text-gray-800'
                }`}>
                  {option?.label}
                </h3>
                <p className="text-sm text-gray-800 font-caption">
                  {option?.description}
                </p>
              </div>
              <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${
                searchType === option?.type
                  ? 'border-secondary bg-secondary' :'border-gray-300'
              }`}>
                {searchType === option?.type && (
                  <div className="w-2 h-2 bg-secondary-foreground rounded-full"></div>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SearchTypeToggle;